/* eslint-disable jsx-a11y/label-has-for */
import React from 'react';
import { GET_LIST, downloadCSV, withDataProvider } from 'react-admin';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Button } from 'ra-ui-materialui';
import jsonExport from 'jsonexport/dist';
import FileDownloadIcon from '@material-ui/icons/GetApp';
import {
  FormControlLabel,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
  CircularProgress,
  LinearProgress,
} from '@material-ui/core';
import { DragDropContext } from 'react-beautiful-dnd';

import _ from 'lodash';
import DroppableLevel1 from './DroppableLevel1';
import './styles.css';

class CustomExportButton extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isSubmitting: false,
      isDialogOpen: false,
      pageNumber: 0,
      rowsPerPage: 0,
      maxRowsPerPage: 100,
      maxRowsPerPageDisabled: true,
      errors: {
        pageNumber: undefined,
        rowsPerPage: undefined,
        maxRowsPerPage: undefined,
      },
      minimalFieldsError: undefined,
      fetchAllData: false,
      fetchedPageCount: 0,
      modelFieldsOrderedAndMerged: [],
    };
    this.onCheckboxChange = this.onCheckboxChange.bind(this);
    this.removeChild = this.removeChild.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { total, modelFields } = nextProps;
    const { maxRowsPerPage, modelFieldsOrderedAndMerged } = this.state;
    if (modelFields && modelFieldsOrderedAndMerged.length === 0) {
      this.setState({ modelFieldsOrderedAndMerged: modelFields });
    }

    if (total) {
      const newPageNumber = 1;
      const newMaxRowsPerPage = total < maxRowsPerPage ? total : maxRowsPerPage;
      const newRowsPerPage = total >= newMaxRowsPerPage ? newMaxRowsPerPage : total;
      this.setState({ pageNumber: newPageNumber, rowsPerPage: newRowsPerPage, maxRowsPerPage: newMaxRowsPerPage });
    }
  }

  onCheckboxChange = (parentOrder, childOrder) => {
    const { modelFieldsOrderedAndMerged } = this.state;
    modelFieldsOrderedAndMerged[parentOrder].fields[childOrder].isSelected = !modelFieldsOrderedAndMerged[parentOrder].fields[childOrder].isSelected;
    this.setState({ modelFieldsOrderedAndMerged });
  }

  onMaxRowsChanged = () => {
    const { maxRowsPerPageDisabled, errors } = this.state;
    const { total } = this.props;
    const isLocking = !maxRowsPerPageDisabled;
    const error = null;
    if (isLocking) {
      const newMax = document.getElementById('maxRowsPerPageTextBox').value;
      const hasError = this.validateMaxRows(newMax);
      if (!hasError) {
        const newPageNumber = 1;
        const newRowsPerPage = total >= newMax ? newMax : total;
        document.getElementById('pageNumberTextBox').value = newPageNumber;
        this.setState({
          maxRowsPerPageDisabled: isLocking,
          maxRowsPerPage: newMax,
          pageNumber: newPageNumber,
          rowsPerPage: newRowsPerPage,
          errors: { ...errors, maxRowsPerPage: error },
        });
      }
    } else {
      this.setState({ maxRowsPerPageDisabled: isLocking });
    }
  }

  onDialogClose = () => {
    const { isSubmitting } = this.state;
    if (!isSubmitting) {
      this.setState({ isDialogOpen: false });
    }
  }

  onDragEnd = async (result) => {
    const {
      source, destination, combine, type, draggableId,
    } = result;
    let { modelFieldsOrderedAndMerged } = this.state;
    if (type === 'droppableArea') {
      if (!combine) {
        if (!source || !destination || source.index === destination.index) {
          return;
        }
        const indexOf = _.findIndex(modelFieldsOrderedAndMerged, { order: source.index });
        if (indexOf >= 0) {
          modelFieldsOrderedAndMerged[indexOf].order = destination.index;

          _.forEach(modelFieldsOrderedAndMerged, (value, index) => {
            if (destination.index < source.index && index >= destination.index && index < source.index) {
            // eslint-disable-next-line no-param-reassign
              value.order += 1;
            } else if (destination.index > source.index && index <= destination.index && index > source.index) {
            // eslint-disable-next-line no-param-reassign
              value.order -= 1;
            }
          });
          modelFieldsOrderedAndMerged = _.orderBy(modelFieldsOrderedAndMerged, ['order']);
          this.setState({ modelFieldsOrderedAndMerged });
        }
      } else {
        let droppableOrderString = combine.draggableId.replace('draggableEntryLevel', '');
        droppableOrderString = droppableOrderString.substring(droppableOrderString.indexOf('_') + 1);
        const droppableOrder = parseInt(droppableOrderString, 10);
        const draggingOrder = source.index;

        const indexOfParent = _.findIndex(modelFieldsOrderedAndMerged, { order: droppableOrder });
        const indexOfChild = _.findIndex(modelFieldsOrderedAndMerged, { order: draggingOrder });
        if (indexOfParent >= 0 && indexOfChild >= 0) {
          const child = modelFieldsOrderedAndMerged[indexOfChild];
          const parent = modelFieldsOrderedAndMerged[indexOfParent];
          let lastOrder = parent.fields.length;
          _.forEach(child.fields, (fieldEntry) => {
            // eslint-disable-next-line no-param-reassign
            fieldEntry.order = lastOrder;
            lastOrder += 1;
          });
          modelFieldsOrderedAndMerged[indexOfParent].fields.push(...child.fields);

          modelFieldsOrderedAndMerged.splice(indexOfChild, 1);
          _.forEach(modelFieldsOrderedAndMerged, (value, index) => {
            if (index >= indexOfChild) {
            // eslint-disable-next-line no-param-reassign
              value.order -= 1;
            }
          });
          this.setState({ modelFieldsOrderedAndMerged });
        }
      }
    } else if (type === 'droppableArea2') {
      if (!source || !destination || source.index === destination.index) {
        return;
      }

      const parentOrder = draggableId.substring(draggableId.indexOf('Level1_') + 'Level1_'.length);
      const parent = modelFieldsOrderedAndMerged[parseInt(parentOrder, 10)];
      const indexOf = _.findIndex(parent.fields, { order: source.index });
      if (indexOf >= 0) {
        modelFieldsOrderedAndMerged[parseInt(parentOrder, 10)].fields[indexOf].order = destination.index;

        _.forEach(modelFieldsOrderedAndMerged[parseInt(parentOrder, 10)].fields, (value, index) => {
          if (destination.index < source.index && index >= destination.index && index < source.index) {
          // eslint-disable-next-line no-param-reassign
            value.order += 1;
          } else if (destination.index > source.index && index <= destination.index && index > source.index) {
          // eslint-disable-next-line no-param-reassign
            value.order -= 1;
          }
        });
        modelFieldsOrderedAndMerged[parseInt(parentOrder, 10)].fields = _.orderBy(modelFieldsOrderedAndMerged[parseInt(parentOrder, 10)].fields, ['order']);
        this.setState({ modelFieldsOrderedAndMerged });
      }
    }
  }

  removeChild = (parentOrder, childOrder) => {
    const { modelFieldsOrderedAndMerged } = this.state;
    const removed = modelFieldsOrderedAndMerged[parentOrder].fields.splice(childOrder, 1);
    _.forEach(modelFieldsOrderedAndMerged[parentOrder].fields, (field, index) => {
      if (index >= childOrder) {
        // eslint-disable-next-line no-param-reassign
        field.order -= 1;
      }
    });
    modelFieldsOrderedAndMerged.push({ fields: [{ ...removed[0], order: 0 }], order: modelFieldsOrderedAndMerged.length });
    this.setState({ modelFieldsOrderedAndMerged });
  }

  validateMaxRows = (newMax) => {
    const { total } = this.props;
    const { errors } = this.state;
    let error;
    if (newMax > total) {
      error = `The maximum rows per page value cannot be greater than the total number of entries (${total})`;
      this.setState({ errors: { ...errors, maxRowsPerPage: error } });
    } else if (newMax <= 0) {
      error = 'The maximum rows per page value needs to be greater than 0';
    }
    this.setState({ errors: { ...errors, maxRowsPerPage: error } });
    return error;
  }

  validatePageNumber = (event) => {
    const { value } = event.target;
    const { total } = this.props;
    const { errors, maxRowsPerPage } = this.state;
    let error;
    let newRowsPerPage = 'N/A';
    if (_.isEmpty(value)) {
      error = 'The page number is required';
    } else if (value <= 0) {
      error = 'The page number needs to be greater than 0';
    } else {
      const maxNumberOfPages = parseInt((total / maxRowsPerPage), 10) + (total % maxRowsPerPage > 0 ? 1 : 0);
      if (value > maxNumberOfPages) {
        error = `The maximum number of pages is ${maxNumberOfPages}`;
      } else {
        const availableTotal = total - ((value - 1) * maxRowsPerPage);
        newRowsPerPage = availableTotal > maxRowsPerPage ? maxRowsPerPage : availableTotal;
      }
    }
    this.setState({
      pageNumber: value,
      errors: { ...errors, pageNumber: error },
      rowsPerPage: newRowsPerPage,
    });
  }

  fetchAllDataChecked = () => {
    const { fetchAllData } = this.state;
    if (!fetchAllData) {
      this.validatePageNumber({ target: { value: '1' } });
      document.getElementById('pageNumberTextBox').value = 1;
      this.setState({ fetchAllData: true });
    } else {
      this.setState({ fetchAllData: false, fetchedPageCount: 0 });
    }
  }

  handleSubmit = async () => {
    const {
      isSubmitting,
      errors,
      pageNumber,
      rowsPerPage,
      maxRowsPerPageDisabled,
      maxRowsPerPage,
      fetchAllData,
      modelFieldsOrderedAndMerged,
    } = this.state;
    const {
      filter,
      sort,
      transformFn,
      exportTitle,
      resource,
      total,
    } = this.props;
    const hasErrors = Object.keys(errors).some(key => errors[key]);
    if (isSubmitting || hasErrors) {
      return;
    }

    const areSomeChecked = modelFieldsOrderedAndMerged.filter(entry => entry.fields.filter(fieldEntry => fieldEntry.isSelected).length > 0).length > 0;
    if (!areSomeChecked) {
      this.setState({ minimalFieldsError: 'One field needs to be selected at minimum' });
      return;
    }
    this.setState({ minimalFieldsError: undefined });

    const isUnlocked = !maxRowsPerPageDisabled;
    if (isUnlocked) {
      document.getElementById('maxRowsPerPageTextBox').value = maxRowsPerPage;
      this.setState({ maxRowsPerPageDisabled: true });
    }
    this.setState({ isSubmitting: true });
    const { dataProvider } = this.props;
    if (!fetchAllData) {
      dataProvider(GET_LIST, resource, { filter, sort, pagination: { page: pageNumber, perPage: rowsPerPage } }, {
        onSuccess: {
          notification: { body: 'Data Retrieved Successfully!', level: 'info' },
          callback: (payload) => {
            try {
              const selectedFields = modelFieldsOrderedAndMerged.map(entry => entry.fields.filter(fieldEntry => fieldEntry.isSelected)).flat().map(fieldEntry => fieldEntry.field);
              const data = transformFn ? transformFn(payload.data, selectedFields) : payload.data;
              const chosen = modelFieldsOrderedAndMerged.map(entry => ({ fields: entry.fields.filter(fieldEntry => fieldEntry.isSelected) })).filter(entry => entry.fields.length > 0);
              const mapped = data.map(dataEntry => chosen.map(({ fields }) => ({
                key: fields.map(({ field }) => field).join(' + '),
                // eslint-disable-next-line no-nested-ternary
                value: fields.reduce((concatenated, { field }) => `${concatenated}${(_.isEmpty(dataEntry[field]) ? '' : ` ${dataEntry[field]}`)}`, ''),
              })));
              const secondMap = mapped.map(entries => entries.reduce((obj, { key, value }) => ({ ...obj, [key]: value.toString().trim() }), {}));
              jsonExport(secondMap, {}, (err, csv) => {
                if (err) {
                  // eslint-disable-next-line no-alert
                  alert(err);
                  this.setState({ isSubmitting: false });
                }
                downloadCSV(csv, exportTitle || 'export');
              });
              this.setState({ isSubmitting: false });
            } catch (err) {
            // eslint-disable-next-line no-alert
              alert(err);
              this.setState({ isSubmitting: false });
            }
          },
        },
        onError: {
          notification: { body: 'Data Retrieved Failed!', level: 'warning' },
          callback: () => {
            this.setState({ isSubmitting: false });
          },
        },
      });
    } else {
      const maxNumberOfPages = parseInt((total / maxRowsPerPage), 10) + (total % maxRowsPerPage > 0 ? 1 : 0);
      const arrayOfPages = ((new Array(maxNumberOfPages)).fill(0)).map((__, index) => index + 1);
      let count = 0;
      const resolvedValues = await Promise.all(arrayOfPages.map(async (page) => {
        let offset = total - ((pageNumber - 1) * maxRowsPerPage);
        offset = offset > maxRowsPerPage ? maxRowsPerPage : offset;
        // eslint-disable-next-line no-await-in-loop
        const result = await dataProvider(GET_LIST, resource, { filter, sort, pagination: { page, perPage: offset } });
        count += 1;
        this.setState({ fetchedPageCount: count });
        return {
          page,
          result: result.data,
        };
      }));
      const values = (_.orderBy(resolvedValues, ['page'])).map(r => r.result).flat(1);
      const selectedFields = modelFieldsOrderedAndMerged.map(entry => entry.fields.filter(fieldEntry => fieldEntry.isSelected)).flat().map(fieldEntry => fieldEntry.field);
      const data = transformFn ? transformFn(values, selectedFields) : values;
      const chosen = modelFieldsOrderedAndMerged.map(entry => ({ fields: entry.fields.filter(fieldEntry => fieldEntry.isSelected) })).filter(entry => entry.fields.length > 0);
      const mapped = data.map(dataEntry => chosen.map(({ fields }) => ({
        key: fields.map(({ field }) => field).join(' + '),
        // eslint-disable-next-line no-nested-ternary
        value: fields.reduce((concatenated, { field }) => `${concatenated}${(_.isEmpty(dataEntry[field]) ? '' : ` ${dataEntry[field]}`)}`, ''),
      })));
      const secondMap = mapped.map(entries => entries.reduce((obj, { key, value }) => ({ ...obj, [key]: value.toString().trim() }), {}));
      jsonExport(secondMap, {}, (err, csv) => {
        if (err) {
          // eslint-disable-next-line no-alert
          alert(err);
          this.setState({ isSubmitting: false });
        }
        downloadCSV(csv, exportTitle || 'export');
      });
      this.setState({ isSubmitting: false, fetchedPageCount: 0 });
    }
  }

  render() {
    const { total } = this.props;
    const {
      isDialogOpen,
      pageNumber,
      rowsPerPage,
      errors,
      maxRowsPerPageDisabled,
      maxRowsPerPage,
      isSubmitting,
      minimalFieldsError,
      fetchAllData,
      fetchedPageCount,
      modelFieldsOrderedAndMerged,
    } = this.state;

    const hasErrors = Object.keys(errors).some(key => errors[key]);
    const areAllChecked = modelFieldsOrderedAndMerged.filter(entry => entry.fields.filter(fieldEntry => !fieldEntry.isSelected).length > 0).length === 0;
    const maxNumberOfPages = parseInt((total / maxRowsPerPage), 10) + (total % maxRowsPerPage > 0 ? 1 : 0);
    return (
      <div>
        <Button
          label="Export"
          onClick={() => this.setState({ isDialogOpen: true, maxRowsPerPage: total > 100 ? 100 : total })}
          disabled={this.state.isSubmitting || total === 0}
        >
          <FileDownloadIcon />
        </Button>
        <Dialog
          open={isDialogOpen}
          onClose={this.onDialogClose}
          maxWidth="lg"
          style={{ height: '100%' }}
          disableBackdropClick={isSubmitting}
        >
          <DialogTitle id="alert-dialog-title">
            {'Export Options'}
          </DialogTitle>
          <DialogContent>
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              <DialogContentText
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  flexGrow: 1,
                  marginTop: 5,
                }}
              >
                Select the fields that you want to display on the exported file
              </DialogContentText>
              <Button
                label={areAllChecked ? 'Uncheck All' : 'Check All'}
                onClick={() => {
                  if (areAllChecked) {
                    const newArray = modelFieldsOrderedAndMerged.map(entry =>
                      ({
                        ...entry,
                        fields: entry.fields.map(fieldEntry => ({ ...fieldEntry, isSelected: false })),
                      }));
                      this.setState({ modelFieldsOrderedAndMerged: newArray });
                  } else {
                    const newArray = modelFieldsOrderedAndMerged.map(entry =>
                      ({
                        ...entry,
                        fields: entry.fields.map(fieldEntry => ({ ...fieldEntry, isSelected: true })),
                      }));
                      this.setState({ modelFieldsOrderedAndMerged: newArray });
                  }
                }}
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  flexGrow: 0,
                }}
                disabled={isSubmitting}
              />
            </div>
            <div className="row" style={{ maxHeight: 400, overflow: 'auto', padding: 8 }}>
              <DragDropContext
                onDragEnd={this.onDragEnd}
              >
                <DroppableLevel1
                  isSubmitting={isSubmitting}
                  modelFieldsOrderedAndMerged={modelFieldsOrderedAndMerged}
                  onCheck={this.onCheckboxChange}
                  removeChild={this.removeChild}
                />
              </DragDropContext>
            </div>
            <div
              className="row"
              style={{
                display: minimalFieldsError ? 'flex' : 'none',
                color: '#f44336',
                fontSize: '0.75rem',
                paddingTop: 10,
                paddingBottom: 10,
              }}
            >
              <span>{minimalFieldsError}</span>
            </div>
            <div className="row">
              <hr
                style={{
                  width: '100%',
                  border: '1px solid lightgrey',
                }}
              />
            </div>
            <div className="row">
              <div className="col50">
                <TextField
                  required
                  autoFocus
                  margin="dense"
                  name="pageNumberTextBox"
                  id="pageNumberTextBox"
                  label="Page Number"
                  type="number"
                  fullWidth
                  defaultValue={pageNumber}
                  disabled={!maxRowsPerPageDisabled || fetchAllData}
                  style={{ width: '100%' }}
                  onChange={this.validatePageNumber}
                  helperText={errors.pageNumber}
                  error={errors.pageNumber}
                />
                <TextField
                  required
                  autoFocus
                  margin="dense"
                  name="rowsPerPageTextBox"
                  id="rowsPerPageTextBox"
                  label="Rows x Page"
                  fullWidth
                  disabled
                  value={rowsPerPage}
                  style={{ width: '100%' }}
                />
                <FormControlLabel
                  style={{ width: '100%' }}
                  control={
                    <Checkbox
                      name="fetchAllData"
                      checked={fetchAllData}
                      onChange={this.fetchAllDataChecked}
                      disabled={isSubmitting}
                    />}
                  label="Fetch All Data"
                />
              </div>
              <div className="col50">
                <div style={{ width: '100%', display: 'block' }}>
                  <TextField
                    required
                    autoFocus
                    margin="dense"
                    name="maxRowsPerPageTextBox"
                    id="maxRowsPerPageTextBox"
                    label="Max Rows Per Page"
                    type="number"
                    fullWidth
                    disabled={maxRowsPerPageDisabled}
                    defaultValue={maxRowsPerPage}
                    style={{ width: '95%', float: 'right' }}
                    helperText={errors.maxRowsPerPage}
                    error={errors.maxRowsPerPage}
                    onChange={event => this.validateMaxRows(event.target.value)}
                  />
                </div>
                <div style={{ width: '100%', display: 'block' }}>
                  <FormControlLabel
                    style={{ float: 'right' }}
                    control={
                      <Checkbox
                        name="maxRowsPerPageCheckbox"
                        checked={maxRowsPerPageDisabled}
                        onChange={this.onMaxRowsChanged}
                        disabled={isSubmitting}
                      />}
                    label={maxRowsPerPageDisabled ? 'Unlock Value' : 'Lock Value'}
                  />
                </div>
              </div>
            </div>
          </DialogContent>
          <DialogActions style={{ paddingTop: 15, paddingBottom: 15 }}>
            <div style={{ width: '50%', textAlign: 'left', paddingLeft: 20 }}>
              { isSubmitting && fetchAllData &&
                <div>
                  <LinearProgress variant="determinate" value={(fetchedPageCount / maxNumberOfPages) * 100} />
                </div>
              }
              <div style={{ marginTop: 5 }}>
                {isSubmitting && !fetchAllData &&
                  <CircularProgress
                    style={{
                      width: '1em',
                      height: '1em',
                      display: 'inline-block',
                    }}
                  />
                }
                <div
                  style={{
                  marginLeft: 10,
                  color: 'rgba(0, 0, 0, 0.38)',
                  fontSize: 14,
                  display: isSubmitting ? 'inline-block' : 'none',
                }}
                >
                  {isSubmitting && !fetchAllData ? 'Processing Data...' : `Fetched ${fetchedPageCount}/${maxNumberOfPages} page(s).`}
                </div>
              </div>
            </div>
            <div style={{ width: '50%', textAlign: 'right' }}>
              <Button
                style={{ paddingRight: 15, marginRight: 10 }}
                variant="contained"
                color="default"
                label="Cancel"
                disabled={isSubmitting}
                onClick={this.onDialogClose}
              />
              <Button
                style={{ paddingRight: 15, marginRight: 15 }}
                variant="contained"
                color="primary"
                label="Export"
                disabled={isSubmitting || hasErrors}
                onClick={this.handleSubmit}
              />
            </div>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

CustomExportButton.propTypes = {
  filter: PropTypes.shape({}),
  sort: PropTypes.shape({}),
  total: PropTypes.number,
};

CustomExportButton.defaultProps = {
  filter: null,
  sort: null,
  total: 0,
};

const mapStateToProps = (state, ownProps) => ({ isRouterLoading: state.admin.loading, resourceData: state.admin.resources[ownProps.resource].data });

export default connect(mapStateToProps, null)(withDataProvider(CustomExportButton));



// WEBPACK FOOTER //
// ./src/components/CustomExportButton/index.js